export default Marquee = () => {
  const sections = document.querySelectorAll('.marquee');

  if (sections.length === 0) return;

  const cloneMarqueeItems = (marquee) => {
    if (!marquee) return;

    const oldCopies = marquee.querySelectorAll('[data-marquee-item-copy]');
    oldCopies.forEach((copy) => copy.remove());

    const original = marquee.querySelectorAll('[data-marquee-item]');
    const inner = marquee.querySelector('.marquee__inner');

    const originalArray = Array.from(original);

    const width = originalArray.reduce(
      (acc, item) => acc + item.offsetWidth,
      0,
    );

    let numClones = Math.max(3, Math.ceil((window.innerWidth * 2) / width));

    // CSS animation requires the number of items to be divisible by 4
    numClones = Math.ceil((numClones + 1) / 4) * 4 - 1;

    for (let i = 0; i < numClones; i++) {
      original.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('data-marquee-item-copy', 'true');
        clone.setAttribute('aria-hidden', '');
        clone.setAttribute('tabindex', '-1');
        inner.appendChild(clone);
      });
    }
  };

  for (const section of sections) {
    const links = section.querySelector('.marquee-links');

    const init = () => {
      cloneMarqueeItems(links);
    };
    init();

    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        init();
    });

    links.classList.add('animate');
  }
};